/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Error_CodeInputs */



/**
* | output |
* | --- |
* | "404" |
*
* @param {Offline_Error_CodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_error_code = /** @type {((inputs?: Offline_Error_CodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Error_CodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("404")
	if (locale === "de") return /** @type {LocalizedString} */ ("404")
	if (locale === "it") return /** @type {LocalizedString} */ ("404")
	if (locale === "ru") return /** @type {LocalizedString} */ ("404")
	if (locale === "es") return /** @type {LocalizedString} */ ("404")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("404")
	if (locale === "ja") return /** @type {LocalizedString} */ ("404")
	if (locale === "hi") return /** @type {LocalizedString} */ ("404")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("404")
	return /** @type {LocalizedString} */ ("404")
});